import { PremiumFeature } from 'gleblu-socket-api';
import { Action, createAction } from 'redux-act';

import { Subscription } from '../../../models/interfaces/Subscriptions';
import TimestampPayload from '../TimestampPayload';

export interface CancelSubscriptionPayload extends TimestampPayload {
  id: string;
  placeUuid: string;
  feature: PremiumFeature;
  cancel: boolean;
}
export const cancelSubscription = createAction<CancelSubscriptionPayload>('CANCEL_SUBSCRIPTION');
export type CancelSubscriptionActionType = Action<CancelSubscriptionPayload>;

export interface SubscriptionCanceledPayload extends TimestampPayload {
  subscription: Subscription;
  placeUuid: string;
  feature: PremiumFeature;
}
export const subscriptionCanceled = createAction<SubscriptionCanceledPayload>('SUBSCRIPTION_CANCELED');

export interface SubscriptionCancelFailedPayload extends TimestampPayload {
  id: string;
}
export const subscriptionCancelFailed = createAction<SubscriptionCancelFailedPayload>('SUBSCRIPTION_CANCEL_FAILED');
